import { PieChart, Pie, ResponsiveContainer, Tooltip, Legend, Cell } from 'recharts';
import type { CategoryDistributionData } from '../../../services/analyticsApi';

const COLORS = ['#d4af37', '#b8962e', '#9c7a28', '#806422', '#644e1c'];

interface CategoryDistributionChartProps {
  data: CategoryDistributionData[];
}

const CategoryDistributionChart: React.FC<CategoryDistributionChartProps> = ({ data }) => {
  return (
    <div style={{ background: 'white', border: '1px solid #ddd', borderRadius: 8, padding: 16 }}>
      <h3 style={{ fontSize: 16, fontWeight: 500, color: '#333', marginBottom: 16 }}>分類分布</h3>
      <ResponsiveContainer width="100%" height={250}>
        <PieChart>
          <Pie
            data={data}
            cx="50%"
            cy="50%"
            labelLine={false}
            label={(entry: any) => `${entry.category} ${entry.percentage}%`}
            outerRadius={80}
            dataKey="count"
          >
            {data.map((_, index) => (
              <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
            ))}
          </Pie>
          <Tooltip />
          <Legend />
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
};

export default CategoryDistributionChart;
